/*  eslint-disable no-async-promise-executor */
//import $http from '../../shared/http';
import $http from '../../shared/http';

export const countries = {
  namespaced: true,
  state: () => {
    return {
      countriesForSelect: null,
      countriesStatesForSelect: null,
      countriesNames: null,
      countriesWithStates: null,
    };
  },
  getters: {
    getCountriesForSelect: (state) => state.countriesForSelect,
    getCountriesStatesForSelect: (state) => state.countriesStatesForSelect,
    getCountriesNames: (state) => state.countriesNames,
    getCountriesWithStates: (state) => state.countriesWithStates,
  },
  mutations: {
    setCountriesForSelect: (state, payload) => (state.countriesForSelect = payload),
    setCountriesStatesForSelect: (state, payload) => (state.countriesStatesForSelect = payload),
    setCountriesNames: (state, payload) => {
      if (Array.isArray(payload)) {
        const processedPayload = payload.map((country) => country.name);
        state.countriesNames = processedPayload;
      }
    },
    setCountriesWithStates: (state, payload) => {
      if (Array.isArray(payload)) {
        const processedPayload = payload.map((country) => {
          return {
            name: country.name,
            states:
              country.states && Array.isArray(country.states)
                ? country.states.map((state) => state.name)
                : [],
          };
        });
        state.countriesWithStates = processedPayload;
      }
    },
  },
  actions: {
    async loadCountriesForSelect({ commit }) {
      return $http('v2')
        .get('countries/select')
        .then((response) => {
          commit('setCountriesForSelect', response.data.data);
          return response;
        });
    },

    async loadCountriesNames({ commit }) {
      return $http()
        .get('/countries?filter=name')
        .then((response) => {
          commit('setCountriesNames', response.data.data);
          return response.data.data;
        });
    },

    async loadCountriesWithStates({ commit }) {
      return $http()
        .get('/countries?with_states=true')
        .then((response) => {
          commit('setCountriesWithStates', response.data.data);
          return response.data.data;
        });
    },

    async loadCountriesStatesForSelect({ commit }, { country_id }) {
      return $http('v2')
        .get(`/countries/${country_id}/states/select`)
        .then((response) => {
          commit('setCountriesStatesForSelect', response.data.data);
          return response.data.data;
        });
    },
  },
};
